// extracted by mini-css-extract-plugin
module.exports = {"theResidencesPortfolio":"style_theResidencesPortfolio__E8Dxj"};